import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

// Assets
import { CloseIcon } from 'assets/images/Icons'

// Styled Elements
import { AlertWrapper, Message, Action } from './Alert.elements'

function Alert(props) {
  // Destructure
  const { open, message, onClose, anchorOrigin, color, autoHideDuration, ...rest } = props

  // Functions
  const handleOnClose = (e) => {
    onClose(e)
  }

  // UseEffects
  useEffect(() => {
    setTimeout(() => {
      handleOnClose()
    }, autoHideDuration)
  }, [open])

  return (
    <AlertWrapper
      anchorOrigin={anchorOrigin}
      open={open}
      onClose={handleOnClose}
      autoHideDuration={autoHideDuration}
      message={message}
      {...rest}
    >
      <Message>{message}</Message>
      <Action onClick={handleOnClose}>
        <CloseIcon size={18} />
      </Action>
    </AlertWrapper>
  )
}

// Default Props
Alert.defaultProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'right',
  },
  open: false,
  autoHideDuration: 3000,
  onClose: () => {},
  color: '',
  message: '',
}

// Proptypes Validation
Alert.propTypes = {
  anchorOrigin: PropTypes.shape({ vertical: PropTypes.string, horizontal: PropTypes.string }),
  open: PropTypes.bool,
  autoHideDuration: PropTypes.number,
  onClose: PropTypes.func,
  color: PropTypes.string,
  message: PropTypes.string,
}

export default Alert
